/* eslint-disable import/first */

// Spark uses Bootstrap 5; its locally vendored CSS is loaded by public/index.html.
import "@fortawesome/fontawesome-free/css/all.min.css";

// Keep Bootstrap behavior for existing Bootstrap dialogs and dropdowns.
import $ from "jquery";
(window as any).$ = (window as any).jQuery = $;

import "bootstrap/dist/js/bootstrap.bundle.min.js";

// ===== CSS riêng của app =====

import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { store } from "./store/store";
import { muiTheme } from "./theme";
import './styles/spark-components.css';
import './styles/ictu-colors.css';

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);

root.render(
    <Provider store={store}>
        <MuiThemeProvider theme={muiTheme}>
            <App />
        </MuiThemeProvider>
    </Provider>
);

reportWebVitals();
